import React from 'react';
import { CourseColor } from '../../../config/course';
import { CorrectAnswer } from '../../../lib/domSlide';
import { FillInTheBlankArticleLessonSlide } from '../../../config/course';
import SlidePracticeBackground from '../../atoms/SlidePracticeBackground';
import FontTitle from '../../atoms/FontTitle';
import Img from '../../atoms/Img';
import Textbox from '../../atoms/Textbox';
import { PrimaryButton } from '../../atoms/Button';
// CSSはインポートした順に生成され、後にインポートしたCSSの方が優先されるので、
// まず他のコンポーネントや共通CSSをインポートして、その後でコンポーネントごとのCSSをインストールすること
// つまり、styles.module.cssのインポートはインポート文の複数行のうちの最後に置いておくのが安全
import styles from './styles.module.css';

export type SlidePracticeFillInTheBlankArticleProps = {
    pageIndex: number;
    slideColor: CourseColor;
    isCheckingAnswers: boolean;
    myAnswers: Array<CorrectAnswer>;
    updateMyAnswersWithIndex: (index:number) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    updateIsCheckingAnswersTrue: (e: React.MouseEvent<HTMLButtonElement>) => void;
} & Omit<FillInTheBlankArticleLessonSlide, 'type'>;


const SlidePracticeFillInTheBlankArticle : React.FC<SlidePracticeFillInTheBlankArticleProps> = ({
    pageIndex,
    slideColor,
    memorizationTitle,
    recallTitle,
    resultTitle = '結果を判定します',
    correctAnswers,
    myAnswers,
    isCheckingAnswers,

    updateMyAnswersWithIndex,
    updateIsCheckingAnswersTrue,
}) => {
    // CSS準備
    const titleClass = styles['dom-slide-title'];           // タイトル設定
    let imageAreaClass = styles['dom-slide-imagearea'];     // 画像エリア設定
    let answerAreaClass = styles['dom-slide-answerarea'];   // 問題・回答エリア設定
    const answerColumnClass = styles['input-item'];         // 問題・回答欄設定
    const buttonAreaClass = styles['button-area'];          // ボタン設定

    // 回答画面と結果画面
    if (pageIndex === 1) {
        imageAreaClass += ' ' + styles['recall'];
        answerAreaClass += ' ' + styles['recall'];
    }

    return (
        <div className={ styles['slide-practice-fill-in-the-blank-article'] }>
            <SlidePracticeBackground bgColor={slideColor} className={styles['dom-slide']}>
                {/* 記憶画面 */}
                { pageIndex === 0 &&
                <div className={styles['dom-slide-area']}>
                    <FontTitle className={titleClass}>{memorizationTitle}</FontTitle>
                    <div className={styles['dom-slide-content']}>
                        <div className={imageAreaClass}>
                            <Img fileName={correctAnswers[0].image} alt='slide_image_0' />
                        </div>
                        <div className={answerAreaClass}>
                            {correctAnswers.map((correctAnswer, idx) => {
                                return (
                                    <React.Fragment key={idx}>
                                        {correctAnswer.sentence}
                                        <span className={styles['keyword']}>{correctAnswer.words[0]}</span>
                                        {correctAnswer.sentence2?.split(/(\n)/).map((phrase, idx2) => <React.Fragment key={idx2}>{phrase.match(/\n/)?<br />:phrase}</React.Fragment>)}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
                }

                {/* 回答画面 */}
                { pageIndex === 1 && !isCheckingAnswers &&
                <div className={styles['dom-slide-area']}>
                    <FontTitle className={titleClass}>{recallTitle}</FontTitle>
                    <div className={styles['dom-slide-content']}>
                        <div className={imageAreaClass}>
                            <Img fileName={correctAnswers[0].image} alt='slide_image_0' />
                        </div>
                        <div className={answerAreaClass}>
                            {correctAnswers.map((correctAnswer, idx) => {
                                // 正答の文字数
                                const numOfAnswerCharactors = correctAnswer.words[0].length;
                                return (
                                    <React.Fragment key={idx}>
                                        {correctAnswer.sentence}
                                        <Textbox
                                            key={idx}
                                            className={answerColumnClass + ' ' + styles['answer-width-'+ numOfAnswerCharactors]}
                                            value={myAnswers[idx]?.words[0] || []}
                                            onChange={updateMyAnswersWithIndex(idx)}
                                            maxLength={numOfAnswerCharactors}
                                        />
                                        {correctAnswer.sentence2?.split(/(\n)/).map((phrase, idx2) => <React.Fragment key={idx2}>{phrase.match(/\n/)?<br />:phrase}</React.Fragment>)}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                        <div className={buttonAreaClass}>
                            <PrimaryButton className={styles['button']} onClick={updateIsCheckingAnswersTrue}>答え合わせする</PrimaryButton>
                        </div>
                    </div>
                </div>
                }

                {/* 結果画面 */}
                { pageIndex === 1 && isCheckingAnswers &&
                <div className={styles['dom-slide-area']}>
                    <FontTitle className={titleClass}>{resultTitle}</FontTitle>
                    <div className={styles['dom-slide-content']}>
                        <div className={imageAreaClass}>
                            <Img fileName={correctAnswers[0].image} alt='slide_image_0' />
                        </div>
                        <div className={answerAreaClass}>
                            {correctAnswers.map((correctAnswer, idx) => {
                                // 回答の正誤判定
                                const value = myAnswers[idx]?.words[0] || '';
                                const resultClass = (correctAnswer.words.includes(value))? styles['correct'] : styles['incorrect'];

                                // 正答の文字数
                                const numOfAnswerCharactors = correctAnswer.words[0].length;
                                const doubleByteSpace = '　' // 半角にすると行の間隔が崩れてしまう。IGNORE_TERM_CONSISTENCY_RULES
                                return (
                                    <React.Fragment key={idx}>
                                        {correctAnswer.sentence}
                                        <span className={answerColumnClass + ' ' + styles['answer-width-'+ numOfAnswerCharactors] + ' ' + resultClass}>{myAnswers[idx]?.words[0] || doubleByteSpace}</span>
                                        {correctAnswer.sentence2?.split(/(\n)/).map((phrase, idx2) => <React.Fragment key={idx2}>{phrase.match(/\n/)?<br />:phrase}</React.Fragment>)}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
                }
            </SlidePracticeBackground>
        </div>
    );
};

export default SlidePracticeFillInTheBlankArticle;
